export default __webpack_public_path__ + "static/media/close.1db27d05.svg";